/**
 * The handful of icons the app needs, as inline SVG.
 *
 * Deliberately not an icon package: this is four glyphs, and a dependency for them would ship a whole
 * library's worth of bundle (or need tree-shaking configured correctly to avoid it) for something a few
 * paths express directly. If the count grows past a dozen, revisit.
 *
 * `aria-hidden` throughout: every one of these sits inside a control that carries its own accessible
 * name, so announcing the icon as well would just read the same thing twice.
 */
function Svg({ children, size = 16 }: { children: React.ReactNode; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export function PencilIcon({ size }: { size?: number }) {
  return (
    <Svg size={size}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </Svg>
  );
}

export function TrashIcon({ size }: { size?: number }) {
  return (
    <Svg size={size}>
      <path d="M3 6h18" />
      <path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
    </Svg>
  );
}

export function PlayIcon({ size }: { size?: number }) {
  return (
    <Svg size={size}>
      <polygon points="6 3 20 12 6 21 6 3" fill="currentColor" stroke="none" />
    </Svg>
  );
}

/** The empty state of the video slot -- an exercise with nothing uploaded yet. */
export function VideoIcon({ size }: { size?: number }) {
  return (
    <Svg size={size}>
      <path d="m22 8-6 4 6 4V8Z" />
      <rect x="2" y="6" width="14" height="12" rx="2" />
    </Svg>
  );
}
